module.exports = __webpack_public_path__ + "static/img/searchMap.b1d206a.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/searchMap.png
// module id = oDwg
// module chunks = 1